import * as React from "react"
import Layout from '../components/layout';
import { graphql, StaticQuery } from "gatsby";
import { Helmet } from "react-helmet";
import LinkCustom from '../components/TransitionLinks/LinkCustom';
import useSiteMetadata from '../components/use-site-metadata';

export default (props) => (
  <StaticQuery
    query={graphql`
      query thetalkcontinuesstories {
        allMarkdownRemark(
          sort: { order: ASC, fields: [frontmatter___name] }
          limit: 1000
        ) {
          nodes {
            frontmatter {
              path
              name
              tags
              quote
              featuredImage{
                publicURL
              }
            }
          }
        }
      }
    `}
    render={data => {

      const { title } = useSiteMetadata();
      const { siteUrl } = useSiteMetadata();
      
      const stories = data.allMarkdownRemark.nodes;

      var i = 0;
      var storylist = stories.map(function(story,index){

        if (story.frontmatter.tags[0] == 'continues') {

          var uniqueClassName = story.frontmatter.path.replace('/', '').toLowerCase();

          i++;
          return (

            <li className={uniqueClassName + " story story-" + i } style={{ backgroundImage: `url(${story.frontmatter.featuredImage.publicURL})` }} key={index}>
              <LinkCustom effect="fade" length={2} url={story.frontmatter.path}>
                <span className="story-quote">“{story.frontmatter.quote}”</span>
              </LinkCustom>
            </li>
  
          )
        }
      })

      return (
        <Layout location={props.location}>
          <Helmet>
            <title>The Talk Continues</title>
            <meta itemprop="name" content={`${"The Talk Continues | "}${title}`}  />
            <meta name="twitter:title" content={`${"The Talk Continues | "}${title}`}  />
            <meta property="og:title" content={`${"The Talk Continues | "}${title}`}  />
            <link rel="canonical" href={`${siteUrl}${"/continues"}`} />
            <meta property="og:url" content={`${siteUrl}${"/continues"}`} />
          </Helmet>
          <section className="page-content-wrapper continues">
            <h1 style={{ display: 'none' }}>The Talk Continues</h1>
            <ul className="story-list">{storylist}</ul>
          </section>
        </Layout>
      )
        

    }}
  />
)